import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['contents'];

  toggle() {
    if (this.contentsTarget.classList.contains('hidden')) {
      this.dispatch('opening', { detail: this });
    }
    this.contentsTarget.classList.toggle('hidden');
  }

  globalClickHandler(e) {
    if (!this.element.contains(e.target)) {
      this.close(null);
    }
  }

  close(event) {
    if (event && event.detail === this) return;
    this.contentsTarget.classList.add('hidden');
  }
}
